import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-filter fs-3" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "modal-header d-flex align-items-start pb-3" }
const _hoisted_8 = { class: "row w-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-4 symbol symbol-circle" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "symbol-label btn-icon-white background_layout_1" }, [
      /*#__PURE__*/_createElementVNode("i", {
        class: "fas fa-filter fs-3",
        style: {"color":"var(--cor_icones_1) !important"}
      })
    ])
  ])
], -1)
const _hoisted_10 = { class: "col-10 d-flex flex-grow-1" }
const _hoisted_11 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_12 = { class: "card-label fw-bolder fs-4 mb-1" }
const _hoisted_13 = { class: "text-muted mt-1 fs-7 fw-light" }
const _hoisted_14 = {
  key: 0,
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_20 = { class: "py-0 ms-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fs-3" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex align-items-center", {'d-none': _ctx.hideFilter}])
  }, [
    _createElementVNode("div", {
      class: "py-0",
      id: `filter-${_ctx.id}`
    }, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-icon background_btn_1_opct",
        style: {"height":"40px","width":"40px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
      }, _hoisted_3)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: `filter-${_ctx.id}-modal`
    }, [
      _createElementVNode("div", {
        class: "modal-dialog",
        id: `filter-${_ctx.id}-modal-dialog`,
        style: _normalizeStyle(`max-width: ${_ctx.modalWidth}`)
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.title), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.subtitle), 1)
                ])
              ])
            ]),
            (!_ctx.hideClose)
              ? (_openBlock(), _createElementBlock("button", _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-12 d-flex mt-6", _ctx.showGoToBack ? 'justify-content-between' : 'justify-content-end'])
              }, [
                (_ctx.showGoToBack)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "btn btn-flex justify-content-between background_btn_1_opct cor_btn_1 btn-sm text-nowrap",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('dashboard')))
                      }, [
                        _hoisted_18,
                        _createTextVNode(" Ir para One Page Report "),
                        _hoisted_19
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    class: _normalizeClass([{disabled: _ctx.disabled}, "btn btn-sm btn-icon background_btn_1_opct"]),
                    style: {"height":"40px","width":"40px"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
                  }, _hoisted_22, 2)
                ])
              ], 2)
            ])
          ])
        ])
      ], 12, _hoisted_5)
    ], 8, _hoisted_4)
  ], 2))
}